import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const Tabs = ({ tabs , className , selectedColor}) => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className={"tabs-container " + className}>
      <div className="tabs-header flex align-items-center justify-space-between">
        {tabs.map((tab, index) => (
          <motion.div
            key={index}
            className={`action-button  small-text tab-button ${
              activeTab === index ? "active " : ""
            }`}
            onClick={() => setActiveTab(index)}
            whileTap={{ scale: 0.95 }}
          >
            {tab.buttonContent ? tab.buttonContent : "null"}
          </motion.div>
        ))}
      </div>
      <div className="tabs-content-container">
        {tabs[activeTab] ? (
          <AnimatePresence mode="popLayout">
            <motion.div
              key={activeTab}
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
            >
              {tabs[activeTab].content ? tabs[activeTab].content : "null"}
            </motion.div>
          </AnimatePresence>
        ) : null}
      </div>
    </div>
  );
};

export default Tabs;
